module.exports = __webpack_public_path__ + "img/mail.b0dbbe0f.svg";